var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contactum-fields" }, [
    _c(
      "ul",
      { class: ["inline" === _vm.field.layout ? "show-inline" : ""] },
      _vm._l(_vm.field.options, function(option) {
        return _c("li", { class: { image_type: option.photo != "" } }, [
          _c("label", [
            _c("input", {
              attrs: { type: "checkbox" },
              domProps: {
                value: option.value,
                checked: _vm.is_selected(option.value)
              }
            }),
            _vm._v(" "),
            option.photo != ""
              ? _c("img", { attrs: { src: option.photo, width: "200px" } })
              : option.photo == ""
              ? _c("span", [_vm._v(_vm._s(option.label))])
              : _vm._e()
          ])
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", {
          staticClass: "help",
          domProps: { innerHTML: _vm._s(_vm.field.help) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }